export default "__VITE_ASSET__D0p0tnao__"